import {useCmsService} from '@/composables/cms_service'

export const useGuideService = () => {

  const {getCmsEntityList, getCmsEntitySingle} = useCmsService()

  const getGuidesList = async (lang) => {
    return getCmsEntityList('guides', lang, 0, -1, null, null, null)
  }

  const getGuideCategories = async (lang) => {
    const response = (await getCmsEntityList('guides', lang, 0, -1, null, null, {field: 'guide_categories.locale', operator: 'eq', value: lang})).map(g => g.guide_categories).flat()
    return [...new Set(response.map(s => s.id))]
      .map(id => {return response.find((r) => r.id === id)})
  }

  const getGuidesByCategory = async (url, lang) => {
    return getCmsEntityList('guides', lang, 0, -1, null, null, {field: 'guide_categories.Url', operator: 'eq', value: url})
  }

  const getGuideByUrl = async (url, lang, populateLocalizations = false) => {
    // workaround for case-insensitive check, find all with contains (which is case-insensitive), then find the exact match.
    const resAll = await getCmsEntitySingle('guides', lang.value, {field: 'Url', operator: 'contains', value: url}, populateLocalizations)
    return resAll && url ? resAll.find(n => n.Url.toLowerCase() === url.toLowerCase()) : null
  }

  const getGuideCategoryByUrl = async (url, lang) => {
    // workaround for case-insensitive check, find all with contains (which is case-insensitive), then find the exact match.
    const resAll = (await getCmsEntitySingle('guides', lang, {field: 'guide_categories.Url', operator: 'contains', value: url})).map(g => g.guide_categories).flat()
    return resAll && url ? resAll.find(n => n.Url.toLowerCase() === url.toLowerCase()) : null
  }

  return {
    getGuidesList,
    getGuideCategories,
    getGuidesByCategory,
    getGuideByUrl,
    getGuideCategoryByUrl
  }
}
